import { CommonFunctions } from '../static/common-functions';
import { DispatchesService } from '../services/dispatches.service';
import { Subscription } from 'rxjs';
import { ConstructionService } from '../services/construction.service';
import { v_DispatchNoteBus } from './v_DispatchNoteBus';
import { DispatchPage } from './DispatchPage';
import { SubcoOrderDetail } from './SubcoOrderDetail';
import { BaseMessageInfo } from './BaseMessageInfo';
import { DispatchContAdjustmentBus } from './DispatchContAdjustmentBus';
import { DispatchCostAdjustmentBus } from './DispatchCostAdjustmentBus';
import { DispatchCurrCostAdjustmentBus } from './DispatchCurrCostAdjustmentBus';
import { DispatchBTDAdjustmentBus } from './DispatchBTDAdjustmentBus';
import { DispatchSixZeroSixAdjustmentBus } from './DispatchSixZeroSixAdjustmentBus';
import { FeatureFlagService } from '../services/feature-flag.service';

export class CnstJobPage extends DispatchPage
{
    svc_const: ConstructionService;
    constructor(svc_data: DispatchesService, data: CnstJobPage = null, svc_const: ConstructionService, featureFlagService: FeatureFlagService)
  {
        super(svc_data, data, featureFlagService);
        this.svc_const = svc_const;
    if (data !== null) {
        this.notes = data.notes;
    }
  }

    clear() {
        super.clear();
        this.notes = null;
        this.subcoOrderDetail = [];
        this.dispatchContAdjustments = [];
        this.dispatchCostAdjustments = [];
        this.dispatchCurrCostAdjustments = [];
        this.dispatchBTDAdjustments = [];
        this.dispatchSixZeroSixAdjustments = [];
        this.notesLoading = false;
        this.subcoOrderDetailLoading = false;
        this.dispatchAttachmentsLoading = false;
        this.dispatchContAdjustmentsLoading = false;
        this.dispatchCostAdjustmentsLoading = false;
        this.dispatchCurrCostAdjustmentsLoading = false;
        this.dispatchBTDAdjustmentsLoading = false;
        this.dispatchSixZeroSixAdjustmentsLoading = false;
 }
    unsubscribe() {
        super.unsubscribe();
      CommonFunctions.unsubscribe(this.subs_notes);
        CommonFunctions.unsubscribe(this.subs_subcoOrderDetail);
        CommonFunctions.unsubscribe(this.subs_dispatchContAdjustments);
        CommonFunctions.unsubscribe(this.subs_dispatchCostAdjustments);
        CommonFunctions.unsubscribe(this.subs_dispatchCurrCostAdjustments);
        CommonFunctions.unsubscribe(this.subs_dispatchBTDAdjustments);
        CommonFunctions.unsubscribe(this.subs_dispatchSixZeroSixAdjustments);
  }
    subs_notes: Subscription; 
    subs_subcoOrderDetail: Subscription; 
    subs_dispatchContAdjustments: Subscription;
    subs_dispatchCostAdjustments: Subscription; 
    subs_dispatchCurrCostAdjustments: Subscription; 
    subs_dispatchBTDAdjustments: Subscription; 
    subs_dispatchSixZeroSixAdjustments: Subscription; 

    getNotes(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.notesLoading = true;
            CommonFunctions.unsubscribe(this.subs_notes);
            this.subs_notes = this.svc_data.getNotesView(id).subscribe(data => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        let newObj: v_DispatchNoteBus = new v_DispatchNoteBus(data[i]);
                        arr.push(newObj);
                    }
                }
                this.notes = arr;
                this.notesLoading = false;
            });
        }
        else {
            this.notes = [];
        }
    }
    getSubcoOrderDetail(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.subcoOrderDetailLoading = true;
            CommonFunctions.unsubscribe(this.subs_subcoOrderDetail);
            this.subs_notes = this.svc_const.getSubcoOrderDetails(id).subscribe((info: BaseMessageInfo) => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(info.primaryReturn)) {
                    for (let i = 0; i < info.primaryReturn.length; i++) {
                        let newObj: SubcoOrderDetail = new SubcoOrderDetail(info.primaryReturn[i]);
                        arr.push(newObj);
                    }
                }
                this.subcoOrderDetail = arr;
                this.subcoOrderDetailLoading = false;
            });
        }
        else {
            this.subcoOrderDetail = [];
        }
    }
    getDispatchContAdjustments(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.dispatchContAdjustmentsLoading = true;
            CommonFunctions.unsubscribe(this.subs_dispatchContAdjustments);
            this.subs_dispatchContAdjustments = this.svc_const.getDispatchContAdjustments(id).subscribe((info: BaseMessageInfo) => {
                let arr = [];
                console.log(JSON.stringify(info));
                if (CommonFunctions.hasValue(info) && !info.saveError && CommonFunctions.hasArrayElementValue(info.primaryReturn)) {
                    for (let i = 0; i <  info.primaryReturn.length; i++) {
                        let newObj: DispatchContAdjustmentBus = new DispatchContAdjustmentBus(info.primaryReturn[i]);
                        arr.push(newObj);
                    }
                    console.log(arr);
                }
                this.dispatchContAdjustments = arr;
                this.dispatchContAdjustmentsLoading = false;
            });
        }
        else {
            this.dispatchContAdjustments = [];
        }
    }
    getDispatchCostAdjustments(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.dispatchCostAdjustmentsLoading = true;
            CommonFunctions.unsubscribe(this.subs_dispatchCostAdjustments);
            this.subs_dispatchCostAdjustments = this.svc_const.getDispatchCostAdjustments(id).subscribe((info: BaseMessageInfo) => {
                let arr = [];
                if (CommonFunctions.hasValue(info) && !info.saveError && CommonFunctions.hasArrayElementValue(info.primaryReturn)) {
                    for (let i = 0; i < info.primaryReturn.length; i++) {
                        let newObj: DispatchCostAdjustmentBus = new DispatchCostAdjustmentBus(info.primaryReturn[i]);
                        arr.push(newObj);
                    }
                }
                this.dispatchCostAdjustments = arr;
                this.dispatchCostAdjustmentsLoading = false;
            });
        }
        else {
            this.dispatchCostAdjustments = [];
        }
    }
    getDispatchCurrCostAdjustments(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.dispatchCurrCostAdjustmentsLoading = true;
            CommonFunctions.unsubscribe(this.subs_dispatchCurrCostAdjustments);
            this.subs_dispatchCurrCostAdjustments = this.svc_const.getDispatchCurrCostAdjustments(id).subscribe((info: BaseMessageInfo) => {
                let arr = [];
                if (CommonFunctions.hasValue(info) && !info.saveError && CommonFunctions.hasArrayElementValue(info.primaryReturn)) {
                    for (let i = 0; i < info.primaryReturn.length; i++) {
                        let newObj: DispatchCurrCostAdjustmentBus = new DispatchCurrCostAdjustmentBus(info.primaryReturn[i]);
                        arr.push(newObj);
                    }
                }
                this.dispatchCurrCostAdjustments = arr;
                this.dispatchCurrCostAdjustmentsLoading = false;
            });
        }
        else {
            this.dispatchCurrCostAdjustments = [];
        }
    }
    getDispatchBTDAdjustments(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.dispatchBTDAdjustmentsLoading = true;
            CommonFunctions.unsubscribe(this.subs_dispatchBTDAdjustments);
            this.subs_dispatchBTDAdjustments = this.svc_const.getDispatchBTDAdjustments(id).subscribe((info: BaseMessageInfo) => {
                let arr = [];
                if (CommonFunctions.hasValue(info) && !info.saveError && CommonFunctions.hasArrayElementValue(info.primaryReturn)) {
                    for (let i = 0; i < info.primaryReturn.length; i++) {
                        let newObj: DispatchBTDAdjustmentBus = new DispatchBTDAdjustmentBus(info.primaryReturn[i]);
                        arr.push(newObj);
                    }
                }
                this.dispatchBTDAdjustments = arr;
                this.dispatchBTDAdjustmentsLoading = false;
            });
        }
        else {
            this.dispatchBTDAdjustments = [];
        }
    }
    getDispatchSixZeroSixAdjustments(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.dispatchSixZeroSixAdjustmentsLoading = true;
            CommonFunctions.unsubscribe(this.subs_dispatchSixZeroSixAdjustments);
            this.subs_dispatchSixZeroSixAdjustments = this.svc_const.getDispatchSixZeroSixAdjustments(id).subscribe((info: BaseMessageInfo) => {
                let arr = [];
                if (CommonFunctions.hasValue(info) && !info.saveError && CommonFunctions.hasArrayElementValue(info.primaryReturn)) {
                    for (let i = 0; i < info.primaryReturn.length; i++) {
                        let newObj: DispatchSixZeroSixAdjustmentBus = new DispatchSixZeroSixAdjustmentBus(info.primaryReturn[i]);
                        arr.push(newObj);
                    }
                }
                this.dispatchSixZeroSixAdjustments = arr;
                this.dispatchSixZeroSixAdjustmentsLoading = false;
            });
        }
        else {
            this.dispatchSixZeroSixAdjustments = [];
        }
    }

    get hasNotes(): boolean {
        return CommonFunctions.hasArrayElementValue(this.notes) || this.notesLoading;
    }
    get hassubcoOrderDetail(): boolean {
        return CommonFunctions.hasArrayElementValue(this.subcoOrderDetail) || this.subcoOrderDetailLoading;
    }
    get hasDispatchContAdjustments(): boolean {
        return CommonFunctions.hasArrayElementValue(this.dispatchContAdjustments) || this.dispatchContAdjustmentsLoading;
    }
    get hasDispatchCostAdjustments(): boolean {
        return CommonFunctions.hasArrayElementValue(this.dispatchCostAdjustments) || this.dispatchCostAdjustmentsLoading;
    }
    get hasDispatchCurrCostAdjustments(): boolean {
        return CommonFunctions.hasArrayElementValue(this.dispatchCurrCostAdjustments) || this.dispatchCurrCostAdjustmentsLoading;
    }
    get hasDispatchBTDAdjustments(): boolean {
        return CommonFunctions.hasArrayElementValue(this.dispatchBTDAdjustments) || this.dispatchBTDAdjustmentsLoading;
    }
    get hasSixZeroSixAdjustments(): boolean {
        return CommonFunctions.hasArrayElementValue(this.dispatchSixZeroSixAdjustments) || this.dispatchSixZeroSixAdjustmentsLoading;
    }

    notes: v_DispatchNoteBus[];
    subcoOrderDetail: SubcoOrderDetail[];
    dispatchContAdjustments: DispatchContAdjustmentBus[];
    dispatchCostAdjustments: DispatchCostAdjustmentBus[];
    dispatchCurrCostAdjustments: DispatchCurrCostAdjustmentBus[];
    dispatchBTDAdjustments: DispatchBTDAdjustmentBus[];
    dispatchSixZeroSixAdjustments: DispatchSixZeroSixAdjustmentBus[];
    notesLoading: boolean = false;
    subcoOrderDetailLoading: boolean = false;
    dispatchContAdjustmentsLoading: boolean = false;
    dispatchCostAdjustmentsLoading: boolean = false;
    dispatchCurrCostAdjustmentsLoading: boolean = false;
    dispatchBTDAdjustmentsLoading: boolean = false;
    dispatchSixZeroSixAdjustmentsLoading: boolean = false;
}
